import React from "react";

const vehicles = [
  {
    image: "/images/fleet/Maruti-Ertiga.png",
    type: "SUV / MUV",
    title: "Maruti Ertiga",
    seats: 6,
    luggage: 4,
    price: "₹1,299",
  },
  {
    image: "/images/fleet/Innova-Crysta.png",
    type: "Premium SUV",
    title: "Toyota Innova Crysta",
    seats: 7,
    luggage: 5,
    price: "₹1,999",
  },
  {
    image: "/images/fleet/Toyota-Rumion.png",
    type: "MUV",
    title: "Toyota Rumion",
    seats: 6,
    luggage: 4,
    price: "₹1,499",
  },
];

const HolidayPackage = () => {
  return (
    <section className="tour--layout4 space space-extra-bottom shape-mockup-wrap p-0 py-3  bggh">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div
            className="col-xl-12 col-lg-12 wow fadeInUp"
            data-wow-delay="0.3s"
          >
            <div className="title-area">
              <span className="sec-subtitle text-white">Our Fleet</span>

              <h2 className="sec-title h1">
                Airport Taxi Vehicles
              </h2>

              {/* <p className="sec-text">
                Choose from our fleet of comfortable and well-maintained
                vehicles for Mumbai Airport pickup, drop, local rides,
                and outstation travel.
              </p> */}
            </div>
          </div>
        </div>

        <div className="row">
          {vehicles.map((vehicle, index) => (
            <div
              key={index}
              className="col-xl-4 col-lg-6 col-sm-6 mb-4"
            >
              <div className="package-style3">
                <div className="package-img">
                  <a>
                    <img
                      className="w-100"
                      src={vehicle.image}
                      alt={vehicle.title}
                    />
                  </a>
                </div>

                <div className="package-content">
                  <p className="package-text">{vehicle.type}</p>

                  <h3 className="package-title">
                    <a href="">{vehicle.title}</a>
                  </h3>

                  <div className="package-meta">
                    <a href="#!">
                      <i className="fas fa-users"></i>
                      {" "}Seats: {vehicle.seats}
                    </a>

                    <a href="#!">
                      <i className="fas fa-suitcase"></i>
                      {" "}Luggage: {vehicle.luggage}
                    </a>
                  </div>

                  <div className="package-footer">
                    <div className="package-review">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                    </div>

                    {/* <span className="package-price">
                      <span>Starting From </span>
                      {vehicle.price}
                    </span> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HolidayPackage;